import { SECTORS } from "@/data/catalog";

export default function SectorPills({ value, onChange }) {
  return (
    <div className="w-full overflow-hidden">
      <div className="flex gap-2 overflow-x-auto no-scrollbar py-2 px-1">
        <button
          onClick={() => onChange("")}
          data-testid="sector-chip-all"
          className={`flex-shrink-0 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium border transition-all ${
            !value ? "bg-emerald-800 text-white border-emerald-800" : "bg-white text-slate-700 border-slate-200 hover:border-emerald-500"
          }`}
        >
          All sectors
        </button>
        {SECTORS.map((s) => (
          <button
            key={s}
            onClick={() => onChange(s)}
            data-testid={`sector-chip-${s.replace(/[^a-z0-9]/gi, "").toLowerCase()}`}
            className={`flex-shrink-0 px-3 sm:px-4 py-2 rounded-full text-xs sm:text-sm font-medium border transition-all whitespace-nowrap ${
              value === s ? "bg-emerald-800 text-white border-emerald-800" : "bg-white text-slate-700 border-slate-200 hover:border-emerald-500"
            }`}
          >
            {s}
          </button>
        ))}
      </div>
    </div>
  );
}
